import { QueryParameter, openComponentInPopup, getComponent } from "./common";
import PrintingTechnologySelector, { PrintingOnlineDemand } from "./printing-technology-selector";
import OrderMatrix from "./order-matrix";
import ProductCount from "./product-count";
import { PopupOptions } from "./popup";
import { InquiryForm } from "./inquiry-form";
import Cart from "./cart";
import { openCalculator } from "./product-detail";
import LoadingIndication from "./loading-indication";

export default class PrintingSelector {
    private linkElement: HTMLAnchorElement;
    private positionId: string;
    private positionImageId: string;
    private modelGuid: string;
    private hasPrice = true;
    private productId: number;
    private productGuid: string;
    private productCount: number;
    private isCalculatorActive: boolean = true;
    private isOutOfStock: boolean;

    constructor(linkElement: HTMLAnchorElement, hasPrice: boolean, productId: number, productGuid: string, productCount: number, isCalculatorActive: boolean, isOutOfStock: boolean) {
        this.linkElement = linkElement;
        this.hasPrice = hasPrice;
        this.productId = productId;
        this.productGuid = productGuid;
        this.productCount = productCount;
        this.isOutOfStock = isOutOfStock;
        this.positionId = linkElement.dataset.printingPositionId;
        this.positionImageId = linkElement.dataset.printingPositionImageId;
        this.modelGuid = linkElement.dataset.modelGuid;
        this.isCalculatorActive = isCalculatorActive;
    }

    public init() {
        this.linkElement.addEventListener("click", (evt) => {
            evt.preventDefault();
            this.openPrintingTechnologiesPopup()
        });
    }

    async openPrintingTechnologiesPopup(): Promise<void> {
        const params: QueryParameter[] = [
            { key: 'printingposition', value: this.positionId },
        ];

        if (this.positionImageId) {
            params.push({ key: 'printingpositionimage', value: this.positionImageId });
        }

        await openComponentInPopup('PrintingTechnologies', params, { id: 'printing-technologies-popup' } as PopupOptions, true);
        const technologiesElement = document.querySelector('[data-component="PrintingTechnologies"]') as HTMLElement;
        new PrintingTechnologySelector(technologiesElement, (tech) => {
            //popup.close();
            this.technologySelected(tech);
        }, this.productCount, this.isCalculatorActive, this.isOutOfStock);
    }

    private async technologySelected(demand: PrintingOnlineDemand): Promise<void> {
        if (!this.hasPrice || this.isOutOfStock) {
            await this.openInquiryForm(demand);
            return;
        }

        if (this.productCount || demand.productCount) {
            const productCount = new ProductCount(this.productId, this.productGuid, demand.productCount ? demand.productCount : this.productCount);

            if (this.isCalculatorActive) {
                await openCalculator([productCount], this.positionId, demand.technology.id);
            } else {
                await this.addSingleProductPrintingGroup(productCount, demand);
            }
            return;
        }

        await this.openOrderMatrix(demand);
    }
    private async openOrderMatrix(demand: PrintingOnlineDemand): Promise<void> {
        await openComponentInPopup(OrderMatrix.componentName, [
            { key: 'position', value: this.positionId },
            { key: 'technology', value: demand.technology.id },
            { key: 'printDescription', value: encodeURIComponent(demand.demandText) }
        ], { id: 'order-matrix-popup' } as PopupOptions, true);

        new OrderMatrix(document.querySelector('#order-matrix-popup'), (counts) => {
            this.productCountSelected(counts, this.modelGuid, this.positionId, demand);
        }, null);
    }

    private async openInquiryForm(demand: PrintingOnlineDemand): Promise<void> {
        const form = new InquiryForm();
        await form.openInPopup(null, [
            { key: 'position', value: this.positionId },
            { key: 'technology', value: demand.technology.id },
            { key: 'printDescription', value: encodeURIComponent(demand.demandText) },
            { key: 'isforprinting', value: "true" }
        ]);
    }

    private async productCountSelected(counts: ProductCount[], modelGuid: string, positionId: string, demand: PrintingOnlineDemand) {
        if (this.isCalculatorActive) {
            await openCalculator(counts, positionId, demand.technology.id);
        } else {
            const cart = new Cart();
            await cart.addPrintingGroup(counts, demand.demandText, positionId, demand.technology.id);
            await cart.openCartDialog(counts);
        }
    }

    private async addSingleProductPrintingGroup(count: ProductCount, demand: PrintingOnlineDemand) {
        this.showLoadingIndication();
        const cart = new Cart();
        await cart.addSingleProductPrintingGroup(count, demand.demandText, this.positionId, demand.technology.id);
        this.hideLoadingIndication();
        await cart.openCartDialog([count]);
    }

    private showLoadingIndication(): void {
        LoadingIndication.show(document.querySelector('[data-component="PrintingTechnologies"]') as HTMLElement);
    }

    private hideLoadingIndication(): void {
        LoadingIndication.hide(document.querySelector('[data-component="PrintingTechnologies"]') as HTMLElement);
    }
}
